import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { SnackBarComponent } from '@core/controls/_snack-bar/snack-bar.component';

export interface SnackMessage {
  icon: string;
  message: string;
  clearPrevious?: boolean;
  isInfinite?: boolean;
}

export interface SnackMessageModel extends SnackMessage {
  id: number;
}

@Injectable({
  providedIn: 'root'
})
export class MessagesService {
  private _snackBarRef: MatSnackBarRef<SnackBarComponent> | null = null;
  private _messages$ = new BehaviorSubject<SnackMessageModel[]>([]);
  private timeOutRefs: { timeout: NodeJS.Timeout | null, msg: SnackMessageModel }[] = [];
  private messageTimeout = 15000;
  public messages$ = this._messages$.asObservable();



  private readonly defaultMessageSettings: SnackMessage = {
    icon: 'info_i',
    clearPrevious: false,
    isInfinite: false,
    message: ''
  }
  constructor(private snackBar: MatSnackBar) { }


  public pushMessage(message: Partial<SnackMessage>): void {
    const msg: SnackMessageModel = { ...this.defaultMessageSettings, ...message, id: new Date().getTime() };

    this.timeOutRefs.push({
      msg,
      timeout: !msg.isInfinite ? setTimeout(() => {
        this.dismissMessage(msg);
      }, this.messageTimeout) : null,
    });

    const prevMsgList = msg.clearPrevious ? [] : this._messages$.value;
    this._messages$.next([...prevMsgList, msg]);

    if (this._messages$.value.length === 1) {
      this._snackBarRef = this.snackBar.openFromComponent(SnackBarComponent);
    }
  }

  public dismissMessage(msg: SnackMessageModel): void {
    const newMsgList = this._messages$.value.filter(m => m.id !== msg.id);
    const timeout = this.timeOutRefs.find(t => t.msg.id === msg.id);

    if (timeout?.timeout) {
      clearTimeout(timeout?.timeout);
    }

    if (newMsgList.length === 0) {
      this._snackBarRef?.dismiss();
    }

    this._messages$.next(newMsgList);
  }

}
